import { render, staticRenderFns } from "./SimpleListAirportPopularDestinations.vue?vue&type=template&id=a544601c&"
import script from "./SimpleListAirportPopularDestinations.vue?vue&type=script&lang=js&"
export * from "./SimpleListAirportPopularDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports